import { Input } from "@/components/ui/input";
import { useDebounceCallback } from "@/shared/hooks/use-debounce-callback";
import { SimpleSelect } from "@/shared/ui/SimpleSelect";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { XIcon } from "lucide-react";
import { useEffect, useState } from "react";

export type IngredientCategoriesSearch = {
  search?: string;
  isActive?: string;
  offset?: number;
  limit?: number;
  sortField?: string;
  sortOrder?: "asc" | "desc";
};

export function IngredientCategoriesFilter() {
  const nav = useNavigate({ from: "/app/inventory/ingredient-categories" });
  const search = useSearch({
    from: "/app/inventory/ingredient-categories",
  }) as IngredientCategoriesSearch;

  const [searchValue, setSearchValue] = useState(search.search ?? "");

  useEffect(() => {
    setSearchValue(search.search ?? "");
  }, [search.search]);

  const debounced = useDebounceCallback((val: string) => {
    setSearchValue(val);
    nav({
      search: {
        ...search,
        offset: 0,
        search: val.trim() ? val.trim() : undefined,
      },
    });
  }, 400);

  const isActiveValue = search.isActive ?? "all";
  const hasFilter = !!search.search?.trim() || isActiveValue !== "all";

  return (
    <div className="flex flex-wrap items-center gap-2 border-b px-4 pb-2">
      <Input
        placeholder="ຄົ້ນຫາຊື່ ຫຼື ລະຫັດ..."
        defaultValue={searchValue}
        onChange={(e) => debounced(e.target.value)}
        className="max-w-xs"
      />
      <SimpleSelect
        placeholder="ສະຖານະ"
        value={isActiveValue}
        onValueChange={(v) => {
          nav({
            search: {
              ...search,
              offset: 0,
              isActive: v === "all" ? undefined : v,
            },
          });
        }}
        options={[
          { value: "all", label: "ທຸກສະຖານະ" },
          { value: "true", label: "ເປີດ" },
          { value: "false", label: "ປິດ" },
        ]}
      />
      {hasFilter && (
        <button
          type="button"
          onClick={() => {
            setSearchValue("");
            nav({
              search: {
                offset: search.offset,
                limit: search.limit,
                sortField: search.sortField,
                sortOrder: search.sortOrder,
              },
            });
          }}
          className="inline-flex items-center gap-1 text-muted-foreground text-sm hover:text-foreground"
        >
          <XIcon className="h-4 w-4" />
          ລ້າງຕົວກອງ
        </button>
      )}
    </div>
  );
}
